import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';
import {
  PaginationDefinition,
  PaginationFormProps,
  PaginationStripProps,
  PaginationMode,
  PaginationPropsCarmiData,
} from '../Pagination.types';

export const props = withCompInfo<
  PaginationStripProps | PaginationFormProps,
  PaginationDefinition,
  PaginationPropsCarmiData
>()(
  ['compData', 'compProps', 'isMobileView'],
  ({ compData, compProps, isMobileView }, carmiProps) => {
    const {
      totalPages,
      currentPage,
      nextText,
      previousText,
      firstText,
      lastText,
    } = compData;
    const { navigationType } = carmiProps;
    const {
      showFirstLastNavButtons,
      showFirstPage,
      showLastPage,
      showInputModeTotalPages,
      paginationDirection,
      paginationMode,
      isDisabled,
    } = compProps;
    const paginationProps = {
      totalPages,
      currentPage,
      nextText,
      previousText,
      firstText,
      lastText,
      showFirstLastNavButtons,
      navigationType,
      paginationDirection,
      isDisabled,
    };
    const propsMapper: {
      [key in PaginationMode]: PaginationFormProps | PaginationStripProps;
    } = {
      input: { ...paginationProps, showTotalPages: showInputModeTotalPages },
      pages: {
        ...paginationProps,
        showFirstLastPageButtons: showFirstPage || showLastPage,
        isResponsiveHeight: isMobileView,
      },
    };
    return propsMapper[paginationMode];
  },
);

export default createComponentMapperModel({ props });
